var React = require('react');

function InfoCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#15212E","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M21 12a9 9 0 1 1-18.001-.001A9 9 0 0 1 21 12zM9.545 17.727h4.91m-4.091-7.363H12v6.954m.001-11.045a.409.409 0 1 0 0 .818.409.409 0 0 0 0-.818"}));
}

InfoCircle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = InfoCircle;

InfoCircle.default = InfoCircle;
